import { OtterPlanType } from '#types';

export const INDIA_COUPON_CODE = 'QGWSF502J98IND2026';

export const MAX_SEATS_PRO_PLAN = 5;
export const MAX_SEATS_TEAM_PLAN = 10;

export const PURCHASE_PLAN_UPGRADE_ANALYTICS =
  'PURCHASE_PLAN_UPGRADE_ANALYTICS';

/**
 * The plan types order from cheapest to most expensive.
 *
 * [Original source](https://github.com/otter-ai/otter-web/blob/9ecc21af165a3ffd035f8538cf1350debf733871/packages/client/src/app/shared/models/avatar-model.ts#L1557)
 */
export const PLAN_TYPES_FROM_LOWEST_TO_HIGHEST_TIER = [
  OtterPlanType.FREE,
  OtterPlanType.PREMIUM,
  OtterPlanType.TEAM,
  OtterPlanType.ENTERPRISE,
] as const;

export const PLAN_TYPE_TO_PLAN_NAME = {
  [OtterPlanType.FREE]: 'Basic',
  [OtterPlanType.PREMIUM]: 'Pro',
  [OtterPlanType.TEAM]: 'Business',
  [OtterPlanType.ENTERPRISE]: 'Enterprise',
} as const;
